module.exports = __webpack_public_path__ + "static/media/04.65790b11.png";